import { Fragment, useContext, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { SignUpFormContext } from "./sign-up-form.context";
import { useSignupToken } from "../hooks/use-signup-token.hook";
import SignUpButton from "./sign-up-form-button/sign-up-form-button.component";
import SignUpFormFields from "./sign-up-form-fields/sign-up-form-fields.component";
import SignUpFormHeader from "./sign-up-form-header/sign-up-form-header.component";
import SignUpFormOptions from "./sign-up-form-options/sign-up-form-options.component";
import SignUpProfileFields from "./sign-up-profile-fields/sign-up-profile-fields.component";
import classNames from "classnames";
import styles from "./sign-up-form-v2.styles.module.scss";
import { SignupTokenType } from "../sign-up-v4.constants";

const SignUpFormV2Component = () => {
  const { t } = useTranslation();
  const { signupTokenType } = useSignupToken();
  const { page, setErrorText, setGcomData } = useContext(SignUpFormContext);

  useEffect(() => {
    if (!signupTokenType || signupTokenType === SignupTokenType.INVITE_SURVEY) {
      return;
    }
    void (async () => {
      try {
        const response = await window.fetch(`${window.gxApiConnection}/api/v4/data/profile`, {
          method: "GET",
          credentials: "include",
        });
        const resJson = await response.json();
        if (response?.status !== 200 || !resJson?.data) {
          throw new Error();
        }
        setGcomData({
          companySize: resJson.data.companySize || [],
          functions: resJson.data.functions || [],
          industries: resJson.data.industries || [],
          countries: resJson.data.countries || [],
        });
      } catch (error) {
        setErrorText(t("Oops... something went wrong. Please try again."));
      }
    })();
  }, [signupTokenType, setErrorText, setGcomData, t]);

  return (
    <div className={classNames(styles.signUpForm)}>
      <SignUpFormHeader />
      <form noValidate autoComplete="off" className={styles.form}>
        {page === 1 &&
          <Fragment>
            <SignUpFormFields />
            <SignUpFormOptions />
          </Fragment>
        }
        {page === 2 && <SignUpProfileFields />}
        <SignUpButton />
      </form>
    </div>
  );
};

export default SignUpFormV2Component;
